import React from 'react';
import './RecommendationsTable.scss';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { Recommendation } from '../../../../types/apiGeneratedTypes';
import { useDispatch, useSelector } from 'react-redux';
import { unassignRecommendationFromMember } from '../../../../api/members';
import { RootState } from '../../../../store/store';
import { setMemberRecommendations } from '../../../../store/recommendationSlice';
import { getRecommendationsList } from '../../../../api/recommendation';
import { toast } from 'react-toastify';
import * as recommendationActions from '../../../../store/recommendationSlice';

interface IProps {
  recommendationData: Recommendation;
}

const RecommendationsTableRow: React.FC<IProps> = ({ recommendationData }) => {
  const dispatch = useDispatch();
  const { memberData } = useSelector((state: RootState) => state.member);
  const assigned_doctor = JSON.parse(sessionStorage.getItem("assigned_doctor") ?? "false");
  const {admin: { role }} = useSelector((state: RootState) => state.admin);
  const visible = ((role !== "doctor") || (assigned_doctor && role === "doctor"));  

  const onOptionClick = async (id: any, action: string) => {
    if (action === 'unassign') {
      // Add safety check for memberData
      if (!memberData?.user_id) {
        console.error('memberData or user_id is missing:', memberData);
        toast.error('Member data not available');
        return;
      }
      
      try {
        await unassignRecommendationFromMember({ 
          recommendation_id: id,
          member_id: memberData.user_id
        });
        // Refresh recommendations list after successful unassign
        const recommendationsList = await getRecommendationsList(0, 1000, '', 'with_doctor_and_nutritionist', undefined, undefined, memberData.user_id);
        dispatch(setMemberRecommendations(recommendationsList));
        toast.success('Recommendation unassigned successfully');
      } catch (error) {
        console.error('Error unassigning recommendation:', error);
        toast.error('Error unassigning recommendation');
      }
    }
    if (action === 'view') {
      // The original code had dispatch(recommendationActions.setRecommendationToView(recommendationData));
      // This line was removed from the new_code, so it's removed here.
      // If the intent was to keep this, it would need to be re-added.
      dispatch(recommendationActions.setRecommendationToView(recommendationData));
    }
  };
  
  return (
    <div className='table-row recommendations-table-row'>
       <div className='test-image'>
        <img src={recommendationData?.image_url ?? recommendationData?.image} alt='recommendation' width='100' height='100'/>
      </div>
      <div className='test-title'>{recommendationData.title}</div>
      <div className='test-description'>{recommendationData.description}</div>
      <div className='actions'>
        {visible && <TableRowActionMenu
          options={[
            { key: 'unassign', value: 'Unassign' },
            { key: 'view', value: 'View' },
          ]}
          id={recommendationData.id}
          onActionMenuClick={onOptionClick}
        />}
      </div>
    </div>
  );
};

export default RecommendationsTableRow;

